import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TodoComponent } from '../../../common/widgets/todo/todo.component';
import { EventCalendarComponent } from '../../../common/event-calendar/event-calendar.component';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../../services/data.service';
import { AlertConfirmService } from '../../../services/alert-confirm.service';
// import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-rec-content',
  imports: [CommonModule, FormsModule, TodoComponent, EventCalendarComponent],
  templateUrl: './rec-content.component.html',
  styleUrl: './rec-content.component.scss',
})
export class RecContentComponent {
  @Input() user: any;

  constructor(
    private auth: AuthService, 
    private router: Router, 
    private alertService: AlertConfirmService, 
    public dataService: DataService,
    // private modalService: ModalService
  ) {
    //
  }

  frmEnquery(optPg: any) {
    // const url: string = 'http://localhost:4200/enq-form';
    // this.openPopupCenter(url, 'Enquery Form', 600, 700);
    // this.router.navigate(['/dashboard/enq-'+optPg]);
  }

  // openModal(btnMax: boolean, isFooter: boolean) {
  //   this.modalService.openModal(
  //     this.dataService.pgType,
  //     this.dataService.getMenuIcon(),
  //     this.dataService.getMenuTitle(),
  //     this.dataService.pgType + ' Body Text Here',
  //     { size: 'lg', maximize: btnMax, footer: isFooter }
  //   );
  // }

  openPopupCenter(url: string, title: string, w: number, h: number) {
    // Fixes dual-screen position and zoom-level issues
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    
    // Open the new centered window
    const newWindow = window.open(url, title, `
      location=no,
      toolbar=no, menubar=no,
      scrollbars=yes, resizable=no,
      popup=true, noopener=false, noreferrer=false,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, left=${left}
    `);

    if (newWindow) {
        newWindow.focus();
    }
  }

}
